<template>
  <Link
    :href="href"
    :as="props.disabled ? 'div' : 'a'"
    :class="[
      active
        ? 'bg-secondary-400 text-white dark:bg-accent3-600'
        : 'text-base hover:bg-secondary-400 hover:text-white dark:hover:bg-accent3-600 dark:text-white',
      'group/link transition-colors',
      iconView ? 'inline-flex justify-center items-center p-2 rounded-full' : 'flex items-center px-2 py-2 rounded-md w-full'
    ]"
  >
    <component
      :is="icon"
      :class="[
        active
          ? 'text-white'
          : 'text-base group-hover/link:text-white',
        iconView ? 'h-8 w-8' : 'mr-3 h-6 w-6 flex-shrink-0'
      ]"
      aria-hidden="true"
    />
    <template v-if="!iconView">
      <slot />
    </template>
  </Link>
</template>

<script setup lang="ts">
import { usePage } from "@inertiajs/vue3";
import type { Component } from "vue";
import { computed } from "vue";

interface Props {
    href: string;
    icon: Component;
    iconView?: boolean;
    disabled?: boolean;
}

const props = defineProps<Props>();

const active = computed(() => {
    const url = usePage().url.split("?")[0];

    return props.href.indexOf(url) !== -1;
});
</script>
